import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import useToast from "@fuse/hooks/useToast";
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import { Tabs, Tab, Button, Box } from "@mui/material";
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { exportToCSV } from "@fuse/utils/generateCsv";
import { setFormData } from '../../reports/store/reportViewDialogReducer';
import StatusComponent from './StatusComponent'
import excel from "../images/ms_excel.png";


export default function PreviewData({ tabValue, successCsvData, errorCsvData, handleNext, setViewDetails, setOverWrite }) {
	const formData_ = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.formData
	);
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const gridRef = useRef();

	const [recordTabValue, setRecordTabValue] = useState(0);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			'aria-controls': `simple-tabpanel-${index}`,
		};
	}

	const handleChangeRecordTabValue = (event, newValue) => {
		setRecordTabValue(newValue);
	};

	const onGridReady = params => {
		// Following line to make the currently visible columns fit the screen  
		params.api.sizeColumnsToFit();

		// Following line dymanic set height to row on content
		params.api.resetRowHeights();
	};

	function downloadSuccessLog(data) {
		const header = Object.keys(data[0])
		const csvArr = [header]
		data.map(item => {
			csvArr.push((Object.values(item)))
		})
		exportToCSV(csvArr, `success_log_csv`)
	}

	function downloadErrorLog(data) {
		const header = Object.keys(data[0])
		const csvArr = [header]
		data.map(item => {
			csvArr.push((Object.values(item)))
		})
		exportToCSV(csvArr, `error_log_csv`)
	}

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	useEffect(() => {
		setRecordTabValue(tabValue)
	}, [tabValue])

	return (
		<>

			<div>
				<div className="flex flex-wrap justify-between mb-36">
					<h4 className="main_page_heading mt-12">Preview</h4>
				</div>

				<div className="badge_info_holder mb-36">
					<img src={excel} alt="icon" />
					<span className="text">{formData_.name}</span>
					<Button className="grey_btn" onClick={() => {
						dispatch(setFormData(null))
						setOverWrite(false)
						setViewDetails(false)
						handleNext('import')
					}}>
						<i className="ti ti-reload" />
					</Button>
				</div>

				<div>
					<Box className='cstm_tabs_holder'>
						<Tabs value={recordTabValue} onChange={handleChangeRecordTabValue} aria-label="basic tabs example" className='tabs_main_holder'>
							<Tab className='each_tab_holder' label="Successful Records" {...a11yProps(0)} />
							<Tab className='each_tab_holder' label="Rejected Records" {...a11yProps(1)} />
						</Tabs>
					</Box>
				</div>

				{recordTabValue === 0 &&
					<>
						<div style={{ marginTop: '-65px' }} className="text-right mb-40">
							{successCsvData.length > 0 &&
								<Button className="primary_maroon_outlined_btn" onClick={() => { downloadSuccessLog(successCsvData) }}>
									<i className="ti ti-download" />
									<span>Download</span>
								</Button>
							}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "100%",
								height: windowHeight + 105,
								fontSize: '12px'
							}}
						>
							<AgGridReact
								ref={gridRef}
                    theme="legacy"
								rowData={successCsvData}
								animateRows
								onGridReady={onGridReady}
								paginationPageSize={10}
							paginationPageSizeSelector={[10, 20, 50, 100]}
								pagination
								components={frameworkComponents}
								columnDefs={successCsvData.length ? (Object.keys(successCsvData[0])).map(header => {
									if (header === "Status Name") {
										return {
											field: header,
											key: header,
											headerName: header,
											sortable: true,
											// floatingFilter = { true } 
											headerComponent: (props) => (CustomFilter(props, header, gridRef)),
											filter: "agTextColumnFilter",
											flex: 1,
											width: 200,
											minWidth: 200,
											cellRenderer: (event) => (<StatusComponent status_name={event.value} />),
											wrapText: true,
											autoHeight: true,
										}
									}
									return {
										field: header,
										key: header,
										headerName: header,
										sortable: true,
										// floatingFilter = { true } 
										headerComponent: (props) => (CustomFilter(props, header, gridRef)),
										filter: "agTextColumnFilter",
										flex: 1,
										width: 200,
										minWidth: 200,
										cellRenderer: (event) => (<StatusComponent status_name={event.value} />),
										wrapText: true,
										autoHeight: true,
									}
								}) : []}
							 />
						</div>
					</>
				}
				{recordTabValue === 1 &&
					<>
						<div style={{ marginTop: '-65px' }} className="text-right mb-40">
							{errorCsvData.length > 0 &&
								<Button className="primary_maroon_outlined_btn" onClick={() => { downloadErrorLog(errorCsvData) }}>
									<i className="ti ti-download" />
									<span>Download</span>
								</Button>
							}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "100%",
								height: windowHeight + 105,
								fontSize: '12px'
							}}
						>
							<AgGridReact
								ref={gridRef}
                    theme="legacy"
								rowData={errorCsvData}
								animateRows
								onGridReady={onGridReady}
								paginationPageSize={10}
							paginationPageSizeSelector={[10, 20, 50, 100]}
								pagination
							components={frameworkComponents}
							columnDefs={errorCsvData.length ? (Object.keys(errorCsvData[0])).map(header => {
									if (header === "Status Name") {
										return {
											field: header,
											key: header,
											suppressSizeToFit: true,
											headerName: header,
											sortable: true,
											headerComponent: (props) => (CustomFilter(props, header, gridRef)),
											filter: "agTextColumnFilter",
											flex: 1,
											minWidth: 200,
											width: 200,
											cellRenderer: (event) => (<StatusComponent status_name={event.value} />),
											wrapText: true,
											autoHeight: true,
										}
									}
									if (header === "Reason for Rejection") {
										return {
											field: header,
											key: header,
											suppressSizeToFit: true,
											headerName: header,
											sortable: true,
											headerComponent: (props) => (CustomFilter(props, header, gridRef)),
											filter: "agTextColumnFilter",
											flex: 1,
											minWidth: 300,
											width: 300,		
											pinned: 'left',
											lockPinned: true,
											wrapText: true,
											autoHeight: true,
											cellStyle: params => {
												return { color: '#B42318', backgroundColor: '#FFFBFA' };
											},
											cellRenderer: (event) =>
												<span style={{ color: '#B42318', wordBreak: 'break-word' }}>
													{event.value?.split(",")[0]}
												</span>
										}
									}
								return {
										field: header,
											key: header,
											suppressSizeToFit: true,
											headerName: header,
											sortable: true,
											headerComponent: (props) => (CustomFilter(props, header, gridRef)),
											filter: "agTextColumnFilter",
											flex: 1,
											minWidth: 200,
											width: 200,
									}
								}): []}
							 />
						</div>
					</>
				}
			</div>

		</>
	)
}